import { useCallback, useEffect, useState, createRef, useRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import GridItem from 'components/GridItem'
import data from 'data.json'

const Grid = ({
  tenant,
  colorMode,
  titleText,
}: {
  tenant?: object
  colorMode?: string
  titleText?: string
}) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <>
      <GraphicWrapper className={isMobile ? 'mobile' : 'desktop'}>
        {titleText && <h3>{titleText}</h3>}
        <GridWrapper className={isMobile ? 'mobile' : 'desktop'}>
          {
            // sort data by difference ascending and map
            data
              .sort((a, b) => Number(a.Differenz) - Number(b.Differenz))
              .map(function (item: any, itemIndex: number) {
                return (
                  <GridItem
                    name={item.Name}
                    canton={item.Kanton}
                    height1960={item['Höhe1960']}
                    height1990={item['Höhe1990']}
                    height2023={item['Höhe2023']}
                    difference={item.Differenz}
                    percentage={item.Prozentual}
                    link={item.Link}
                    index={itemIndex}
                    colorMode={colorMode}
                    key={itemIndex}
                  ></GridItem>
                )
              }, [])
          }
        </GridWrapper>
        <div className='source'>
          Daten:{' '}
          <a href='https://www.swisstopo.admin.ch/de/karten-daten-online/karten-geodaten-online/zeitreise.html'>
            Swisstopo
          </a>
        </div>
      </GraphicWrapper>
    </>
  )
}
const GraphicWrapper = styled.div`
  max-width: 1111px;
  margin: 0 auto;
  padding: 2rem 0;

  h3 {
    margin-bottom: 3rem;
  }
  .source,
  .source a {
    color: var(--gray-3);
    font-size: 1.4rem;
    line-height: 2rem;
    margin-top: 0.3rem;
    margin-bottom: 0;
  }
`

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 2.4rem;
  @media only screen and (min-width: 600px) {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 3.4rem;
  }
  @media only screen and (min-width: 769px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media only screen and (min-width: 1024px) {
    grid-template-columns: repeat(5, 1fr);
  }
`

export default Grid
